import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["imageInput", "dropzone", "placeholder", "preview", "previewImg", "filename", "alwaysOn", "dateFields"]
  static values = {
    fileTooLarge: { type: String, default: "파일 크기는 5MB 이하여야 합니다." }
  }

  connect() {
    this._bindDropEvents()
    this._toggleDateFields()
  }

  onFileChange() {
    this._handleFile(this.imageInputTarget.files[0])
  }

  clearImage() {
    this.imageInputTarget.value = ""
    this.placeholderTarget.style.display = "block"
    this.previewTarget.style.display = "none"
    this.previewImgTarget.src = ""
    this.filenameTarget.textContent = ""
  }

  toggleAlwaysOn() {
    this._toggleDateFields()
  }

  _toggleDateFields() {
    if (!this.hasAlwaysOnTarget || !this.hasDateFieldsTarget) return
    const disabled = this.alwaysOnTarget.checked
    this.dateFieldsTarget.style.opacity = disabled ? "0.4" : "1"
    this.dateFieldsTarget.querySelectorAll("input[type=date]").forEach(el => {
      el.disabled = disabled
    })
  }

  _handleFile(file) {
    if (!file) return
    if (!file.type.startsWith("image/")) return
    if (file.size > 5 * 1024 * 1024) {
      alert(this.fileTooLargeValue)
      return
    }

    this.placeholderTarget.style.display = "none"
    this.previewTarget.style.display = "block"
    this.filenameTarget.textContent = file.name

    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewImgTarget.src = e.target.result
      this.previewImgTarget.style.display = "block"
    }
    reader.readAsDataURL(file)
  }

  _bindDropEvents() {
    if (!this.hasDropzoneTarget) return

    this.dropzoneTarget.addEventListener("dragover", (e) => {
      e.preventDefault()
      this.dropzoneTarget.style.borderColor = "#4F46E5"
      this.dropzoneTarget.style.background = "#EEF2FF"
    })

    this.dropzoneTarget.addEventListener("dragleave", (e) => {
      e.preventDefault()
      this.dropzoneTarget.style.borderColor = "#E5E7EB"
      this.dropzoneTarget.style.background = ""
    })

    this.dropzoneTarget.addEventListener("drop", (e) => {
      e.preventDefault()
      this.dropzoneTarget.style.borderColor = "#E5E7EB"
      this.dropzoneTarget.style.background = ""
      const file = e.dataTransfer.files[0]
      if (!file) return
      const dt = new DataTransfer()
      dt.items.add(file)
      this.imageInputTarget.files = dt.files
      this._handleFile(file)
    })
  }
}
